module.exports = __webpack_public_path__ + "media/images/athletes/4-f108760161b42c113e6d6a07f3b642f4.png";